<template>
    <section>
        <form @submit.prevent="next()" novalidate>
        <div class="t-headline5 mt3">
            {{$t('1625')}}
            <!-- 개인정보 입력 -->
        </div>
        <div class="t-body3 mt6 t-color-content1">
            {{$t('1626')}}
            <!-- 계정으로 사용할 이메일을 입력하세요. -->
        </div>
        <div class="mt38">
            
            <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                :class="submitState && emailInvalidCheck ? 'mdc-text-field--invalid' : ''"
                id="emailEl"
            >
                <i class="material-icons mdc-text-field__icon">
                    {{validIcon}}
                </i>
                <input type="email" class="mdc-text-field__input"
                    v-model="email"
                    v-validate="'required|email'"
                    ref="email"
                    id="email"
                    name="email"
                    maxlength="50"
                >
                <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    <label for="tf-outlined" class="mdc-floating-label">
                        {{$t('1627')}}
                        <!-- 이메일 -->
                    </label>
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                </div>
                
            </div>
            <div class="t-helper text-helper warning">
                <span v-show="submitState && emailInvalidCheck">
                    {{$t('1630')}}
                </span>
            </div>
        </div>
        <div class="mt26 mb19">
            <button class="mdc-button mdc-button--raised btn-red mr8">
                {{$t('1628')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white" @click="cancelJoin()" type="button">
                {{$t('1629')}}
                <!-- 취소 -->
            </button>
        </div>

        
        </form>
    </section>
    
</template>

<script>
/**
 * 아이디 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'

export default {
    data() {
        return {
            email: '',
            emailTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [joinMixin],

    computed : {
        ...mapState('join',{
            join : state => state,
        }),
       
        // email 유효성 Check 및 아이콘
        emailInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('email')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }
            this.emailTextField.valid === !returnValue ? '' : this.emailTextField.valid = !returnValue
            return returnValue
        },

    },
    
    created() {
        if (!this.join.role || !this.join.responsibility || !this.join.terms.TERMS_OF_SERVICE || !this.join.name.first || !this.join.name.last) {
            //this.$router.go(-1)
        }
    },
    

    mounted() {
        this.setMaterialUi()
        this.$refs.email.focus()
    },

    methods: {
        // Store 변이 정의
        ...mapMutations('join', ['SET_LOGINID']),

        setMaterialUi() {
            this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
            this.emailTextField.useNativeValidation = false
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })

            this.email = this.join.loginId
            this.emailTextField.value = this.email
            
        },

        next() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let params = { userId: this.email }
                    joinApi.existsId(params).then((response) => {
                        //console.log(response.data.data)
                        if (response.data.data) {
                            let params = {
                                // title:'이미 가입된 이메일',
                                // content: '이미 가입된 이메일 계정입니다.로그인하거나 이메일 확인 후 다시 입력하세요.',
                                // accept: '확인',
                                // cancel: '로그인하기'
                                title: this.$t('1641'),
                                content: this.$t('1642') + ' ' + this.$t('1643'),
                                accept: this.$t('1645'),
                                cancel: this.$t('1644')
                            }
                            this.$confirm(params).then(() => {
                                this.email = ''
                            }).catch(() => {
                                this.$moveLogin()
                                
                                
                            })
                        } else {
                            this.SET_LOGINID(this.email)
                            this.$router.push({name: 'JoinPassword'})
                        }
                        
                    }).catch((err) => {
                        
                    })
                    
                    //this.$router.push({name: 'JoinEmail'})                    
                } else{
                    this.focusFirstInvalidElement()
                }
            })
        }
    },

    

}
</script>

<style scoped>

</style>
